import { apiService } from '@/services/api'
import { Winemaker } from '@/types'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useWinemakersStore = defineStore('winemakers', () => {
    const winemakers = ref<Winemaker[]>([])
    const isLoading = ref(false)
    const error = ref<string | null>(null)

    const pagination = ref<{
        page: number
        limit: number
        total: number
        pages: number
    } | null>(null)

    const loadWinemakers = async (
        params: { page?: number; limit?: number } = { page: 1, limit: 10 }
    ) => {
        try {
            isLoading.value = true
            error.value = null

            const response = await apiService.getWinemakers({
                page: params.page ?? 1,
                limit: params.limit ?? 10,
            })

            // Реальная структура: response.data уже содержит {items, page, limit, total, pages}
            const responseData = response?.data as
                | { items: Winemaker[]; page: number; limit: number; total: number; pages: number }
                | undefined
            const items: Winemaker[] = Array.isArray(responseData?.items) ? responseData!.items : []
            winemakers.value = items

            if (responseData && typeof responseData.page === 'number') {
                pagination.value = {
                    page: responseData.page,
                    limit: responseData.limit,
                    total: responseData.total,
                    pages: responseData.pages,
                }
            } else {
                pagination.value = null
            }

            return { success: true, data: { items, pagination: pagination.value } }
        } catch (e: unknown) {
            error.value = (e as Error)?.message || 'Ошибка загрузки виноделов'
            return { success: false, error: error.value }
        } finally {
            isLoading.value = false
        }
    }

    return {
        winemakers,
        isLoading,
        error,
        pagination,
        loadWinemakers,
    }
})
